
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_2","data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27.32 32.01"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M8.86 25.22l-1.93-.53 5.74-21L18.52.22l-1.65 6.86-3.59 2.11zM14.39 5L14 6.44l1.12-.66.33-1.38z","transform":"translate(-1.63)"}}),_c('path',{staticClass:"cls-1",attrs:{"transform":"rotate(-74.75 5.965 30.334)","d":"M4.53 28.52h4.5v1.5h-4.5z"}}),_c('path',{staticClass:"cls-1",attrs:{"transform":"rotate(-33.85 9.981 31.151)","d":"M10.05 26.23h1.5v4.51h-1.5z"}}),_c('path',{staticClass:"cls-1",attrs:{"transform":"rotate(-33.86 3.09 29.532)","d":"M1.66 26.12h4.51v1.5H1.66z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M25 11.76h-7.08L21 0h4.1zm-4.48-2H23L23.07 2h-.55z","transform":"translate(-1.63)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M23.32 30.66H17.8a3.64 3.64 0 01-1.37-.37A4.12 4.12 0 0114 27.54a2.84 2.84 0 010-1.05l2.4-16.73H25v14.39h-1A2.9 2.9 0 0021.88 29zm-5.19-18.9l-2.13 15a.77.77 0 000 .24 2.12 2.12 0 001.24 1.42 2.65 2.65 0 00.61.21h1.58a4.61 4.61 0 01-.27-1.56A4.9 4.9 0 0123 22.3V11.76z","transform":"translate(-1.63)"}}),_c('circle',{attrs:{"cx":"22.39","cy":"27.08","r":"3.93","fill":"#fff"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M24 32a4.93 4.93 0 115-4.92A4.94 4.94 0 0124 32zm0-7.86a2.93 2.93 0 103 2.94 2.94 2.94 0 00-3-2.93z","transform":"translate(-1.63)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M24 28.92a1.84 1.84 0 111.83-1.84A1.84 1.84 0 0124 28.92zm0-2.67a.84.84 0 00-.84.83.85.85 0 00.84.84.84.84 0 00.83-.84.83.83 0 00-.83-.83z","transform":"translate(-1.63)"}})])
          )
        }
      }
    